module.exports = __webpack_public_path__ + "media/images/tenor_attribution-85149d9f1efe47d175b59bc9bb1bbd8e.png";